/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import {
  fetchData,
  formattedMessage,
  toasterrormsg,
  useMenuIdPermissions,
} from '../../../reusable'
import moment from 'moment'
import { useAuthStore } from '../store/UseAuthStore'
import { Tr } from '../../../_metronic/i18n/Tr'

interface MessageModel {
  senderId: string
  helpandsupportId: number
  helpandsupportchatId: number
  receiverId: number
  type: string
  text: any
  time: string
  avatar: string
  name: string
}

interface TicketData {
  supportCode: string
  recordType: string
  recordId: string
  description: string
  subject: string
  created: string
  duration: string
}

const ChatInner: FC<{ isDrawer?: boolean }> = ({ isDrawer = false }) => {
  const { urlData } = useMenuIdPermissions()
  const id = urlData?.id
  const userId = urlData?.userId
  const  t = Tr()

  const [chatUpdateFlag, toggleChatUpdateFlat] = useState(false)
  const [message, setMessage] = useState('')
  const [receiverUserId, setReceiverUserId] = useState<number | null>(null)
  const [messages, setMessages] = useState<MessageModel[]>([])
  const [ticketData, setTicketData] = useState<TicketData | null>(null)
  const [shouldScroll, setShouldScroll] = useState(false)
  const [isData, setIsData] = useState(false)
  const [limit, setLimit] = useState(20)
  const [offset, setOffset] = useState(0)
  const [isLoading, setIsloading] = useState(true)
  const [isFirstLoad, setIsFirstLoad] = useState(true)
  const [profile, setProfile] = useState('')
  const bottomRef = useRef<HTMLDivElement | null>(null)
  const messagesContainerRef = useRef<HTMLDivElement | null>(null)
  const wsRef = useRef<WebSocket | null>(null)
  const tmp = JSON.parse(sessionStorage.getItem('admin') || '{}')
  const adminId = tmp.adminId
  const textareaRef = useRef<HTMLTextAreaElement | null>(null)
  const [showScrollButton, setShowScrollButton] = useState(false)
  const [detailServiceType, setDetailServiceType] = useState('')
  const [detailMobileNumber, setDetailMobileNumber] = useState('')
  const [detailEmail, setDetailEmail] = useState('')
  const [detailName, setDetailName] = useState('')
  const { setSupportCount } = useAuthStore()

  const isUserAtBottom = () => {
    const el = messagesContainerRef.current
    if (!el) return false
    return el.scrollHeight - el.scrollTop <= el.clientHeight + 10
  }

  const scrollToBottomSmooth = () =>
    bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  const scrollToBottom = () => bottomRef.current?.scrollIntoView({ block: 'nearest' })

  useEffect(() => {
    if (shouldScroll) {
      scrollToBottomSmooth()
      setShouldScroll(false)
    }
  }, [messages, shouldScroll])

  const sendMessage = async () => {
    if (!message.trim() || !wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) return

    const msgObject = {
      helpandsupportId: id,
      senderId: adminId,
      senderType: 'ADMIN',
      receiverId: receiverUserId || userId,
      messageType: 'TEXT',
      message: message.trim(),
    }

    try {
      wsRef.current.send(JSON.stringify(msgObject))      
      setMessage('')
    } catch (error) {
      // console.error('WebSocket send error:', error)
    }
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      sendMessage()
    }
  }
  useEffect(() => {
    let reconnectAttempts = 0
    const maxReconnectAttempts = 5  
    const reconnectInterval = 3000
    let ws: WebSocket | null = null
    const connectWebSocket = () => {
      setIsloading(true)
      const socketUrl = `${import.meta.env.VITE_CHAT_BASE_URL}?supportId=${id}&userType=ADMIN`
      // const socketUrl = `wss://api.gogagner.com/uz/addsupportchat?supportId=${id}&userType=ADMIN`
      
      ws = new WebSocket(socketUrl)

      wsRef.current = ws

      ws.onopen = () => {
        
        reconnectAttempts = 0
        setIsloading(false)
      }

      ws.onmessage = (event) => {
        
        try {
          const parsed = JSON.parse(event.data)

          if (!isData) setIsData(true)

          if (parsed.type == 'messageSaved') {
            setTimeout(() => {
              scrollToBottomSmooth()
            }, 150)
          }
          
          if (
            parsed.type === 'messageSaved' ||
            (parsed.type === 'messageReceived' && parsed.data)
          ) {            
            const item = parsed.data

            const newMessage: MessageModel = {
              senderId: item.senderId,
              helpandsupportId: item.helpandsupportId,
              helpandsupportchatId: item.helpandsupportchatId,
              receiverId: item.receiverId,
              type: item.senderType,
              text: item.message,
              time: moment(item.created).format('DD/MM/YYYY hh:mm A'),
              avatar: item.senderType === 'ADMIN' ? '' : profile,
              name: item.senderType === 'ADMIN' ? 'Admin' : detailName,
            }

            setMessages((prev) => [...prev, newMessage])

            if (isUserAtBottom()) {
              setShouldScroll(true)
            }
          }
        } catch (error) {
          console.error('Error parsing WebSocket message', error)
        }
      }

      ws.onerror = () => {
        setIsloading(false)
      }

      ws.onclose = () => {
        setIsloading(false)
        if (reconnectAttempts < maxReconnectAttempts) {
          reconnectAttempts++
          setTimeout(connectWebSocket, reconnectInterval)
        } else {
          console.error('Max WebSocket reconnect attempts reached.')
        }
      }
    }

    connectWebSocket()

    return () => {
      ws?.close()

      wsRef.current = null
    }
  }, [adminId])

  useEffect(() => {
    const el = messagesContainerRef.current
    if (!el) return

    const handleScroll = () => {
      const isAtTop = el.scrollTop < 200
      if (isAtTop && !isLoading && isData) {
        setOffset((prevOffset) => {
          const newOffset = prevOffset + limit
          messageListApiCall(true, newOffset)
          return newOffset
        })
      }

      const shouldShow = el.scrollHeight - el.scrollTop - el.clientHeight > 100
      setShowScrollButton(shouldShow)
    }

    el.addEventListener('scroll', handleScroll)
    return () => el.removeEventListener('scroll', handleScroll)
  }, [isLoading, isData])

  const messageListApiCall = async (appendTop: boolean = false, passedOffset?: number) => {
    setIsloading(true)
    const currentOffset = passedOffset !== undefined ? passedOffset : offset

    const param = {
      helpandsupportId: id,
      limit: limit,
      offset: currentOffset,
    }

    try {
      const response: any = await fetchData('admin/viewsupportchat', param)

      if (response.status == '200') {
              setSupportCount(true)

        const data = response.data.data

        if (data.length > 0) {
          setIsData(true)

          const newMessages = data.map((item: any) => ({
            senderId: item.senderId,
            helpandsupportchatId: item.helpandsupportchatId,
            name: item.userDetail?.fullName || 'User',
            avatar: item.userDetail?.profile || '',
            helpandsupportId: item.helpandsupportId,
            receiverId: item.receiverId,
            type: item.senderType,
            text: item.message,
            time: moment(item.created).format('DD/MM/YYYY hh:mm A'),
          }))

          if (data[0].userDetail?.userId) {
            setReceiverUserId(data[0].userDetail.userId)
          }

          setMessages((prevMessages) => {
            const existingIds = new Set(prevMessages.map((m) => m.helpandsupportchatId))
            const filteredMessages = newMessages.filter(
              (msg: any) => !existingIds.has(msg.helpandsupportchatId)
            )
            return appendTop
              ? [...filteredMessages, ...prevMessages]
              : [...prevMessages, ...filteredMessages]
          })

          if (!appendTop) {
            if (isFirstLoad) {
              setTimeout(() => {
                scrollToBottom()
                setIsFirstLoad(false)
              }, 0)
            } else {
              setShouldScroll(isUserAtBottom())
            }
          } else {
            const el = messagesContainerRef.current
            if (el) {
              const prevScrollHeight = el.scrollHeight
              const prevScrollTop = el.scrollTop
              setTimeout(() => {
                const newScrollHeight = el.scrollHeight
                el.scrollTop = newScrollHeight - prevScrollHeight + prevScrollTop
              }, 0)
            }
          }

          toggleChatUpdateFlat((flag) => !flag)
        } else if (!appendTop && messages.length === 0) {
          setIsData(false)
        }
      } else {
        setIsData(false)
      }
    } catch (err) {
      console.error('Error fetching messages:', err)
      setIsData(false)
    } finally {
      setIsloading(false)
    }
  }

  // user details apicalll


  // ticket detail api call

  const ticketDetailsApiCall = async () => {
    const param: any = {
      helpandsupportId: id,
    }

    const res = await fetchData('admin/viewsupport', param)

    if (res.status == '200') {
      const data = res.data.data[0]
      setTicketData(data)
    } else {
      toasterrormsg(res.message)
    }
  }

  const updateMessageReadCount = async () => {
    const param: any = {
      userType: 'ADMIN',
      helpandsupportId: id,
    }

    const res = await fetchData('admin/readsupportchat', param)

    if (res.status == '200') {
      // const data = res.data.data[0]
      // setTicketData(data)
    } else {
      toasterrormsg(res.message)
    }
  }

  useEffect(() => {
    ticketDetailsApiCall()
    messageListApiCall()
    textareaRef.current?.focus()
  }, [])

  const getFormattedDateLabel = (date: string): string => {
    const msgDate = moment(date, 'DD/MM/YYYY hh:mm A')
    const now = moment()

    if (msgDate.isSame(now, 'day')) return 'Today'
    if (msgDate.isSame(now.clone().subtract(1, 'day'), 'day')) return 'Yesterday'
    if (msgDate.isAfter(now.clone().subtract(6, 'days'))) return msgDate.format('dddd') // Monday, etc.
    return msgDate.format('D MMMM YYYY') // e.g. 20 June 2024
  }

  let lastRenderedDate = ''

  useEffect(() => {
    updateMessageReadCount()
  }, [id, messages])

  const getUserOrVendorDetails = async () => {
    if (!ticketData?.recordType || !ticketData?.recordId) return

    const recordType = ticketData.recordType
    const recordId = ticketData.recordId

    if (recordType == 'VENDOR') {
      const param: any = {
        vendorId: String(recordId),
      }

      const response: any = await fetchData('vendor/public/viewProfile', param)

      if (response.status != '200') {
        toasterrormsg(response.message)
      } else {
        const data = response.data[0]

        setDetailName(data.fullName)
        setDetailEmail(data.email)
        setDetailMobileNumber(data.mobileNumber)
        setDetailServiceType(data.categoryName)
        setProfile(data.logo)
      }
    } else if (recordType == 'USER') {
      const param: any = {
        userId: String(recordId),
      }

      const res: any = await fetchData('admin/viewUserDetail', param)

      if (res.status != '200') {
        toasterrormsg(res.message)
      } else {
        const data = res.data[0]
        setDetailName(data.fullName)
        setDetailEmail(data.email)
        setDetailMobileNumber(data.mobileNumber)
        setProfile(data.profile)

      }
    }
  }

  useEffect(() => {
    if (ticketData?.recordType) {
      getUserOrVendorDetails()
    }
  }, [ticketData?.recordType])
  return (
    <>
      <div className='row'>
        <div className='col-lg-6 my-5'>
          <div className='card border-0 shadow-sm rounded-3'>
            <div className='card-body p-4'>
              {/* Header Section */}
              <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3'>
                {/* Ticket Number */}
                <div>
                  <span className='badge bg-success fs-6 px-3 text-white py-2'>
                    #{ticketData?.supportCode}
                  </span>
                </div>

                {/* Created Date */}
                <div className='text-md-end'>
                  <h6 className='text-muted mb-1 small'>{t("Created On")}</h6>
                  <p className='mb-0 fw-medium'>
                    {moment(ticketData?.created).format('DD MMM YYYY, hh:mm A')}
                  </p>
                </div>
              </div>

              {/* Subject + Description */}
              <div className='p-4  rounded-3 mb-4'>
                <h6 className='text-muted mb-2 '>{t("Subject")}</h6>
                <h4 className='fw-bold text-dark mb-3'>{ticketData?.subject}</h4>

                <h6 className='text-muted mb-2 '>{t("Description")}</h6>
                <p className=' mb-0'>{ticketData?.description}</p>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-6 my-5'>
          <div className='card border-0 shadow-sm rounded-3'>
            <div className='card-body p-4'>
              {/* Header Section */}
              <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3'>
                {/* Ticket Number */}
                <div className='fs-4 fw-bold'>
                  {ticketData?.recordType == 'USER' ? t('User Details') : t('Vendor Details')}
                </div>
              </div>

              {/* Subject + Description */}
              <div className='p-4 rounded-3 mb-4'>
                {/* User/Vendor Details */}
                <>
                  <p className='mb-1'>
                    <strong>{t("Name")}:</strong> {detailName}
                  </p>
                  <p className='mb-1'>
                    <strong>{t("Email")}:</strong> {detailEmail}
                  </p>
                  <p className='mb-1'>
                    <strong>{t("Mobile Number")}:</strong> {detailMobileNumber}
                  </p>
                </>

                {ticketData?.recordType === 'VENDOR' && (
                  <>
                    <p className='mb-1'>
                      <strong>{t("Service Type")}:</strong> {detailServiceType}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className='card-body shadow-sm rounded'
        id={isDrawer ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}
      >
        <div className='chat-wrapper bg-white rounded position-relative'>
          {/* Header */}
          <div className='d-flex align-items-center justify-content-between p-5 shadow-sm mb-4'>
            <div className='d-flex align-items-center w-100'>
              <div className='symbol symbol-45px symbol-circle me-3'>
                <img
                  src={profile || toAbsoluteUrl('/media/logos/mainLogo.png')}
                  alt='User'
                  onError={(e) => {
                    e.currentTarget.onerror = null
                    e.currentTarget.src = toAbsoluteUrl('/media/logos/mainLogo.png')
                  }}
                />
              </div>
              <div className='d-flex flex-column'>
                <span className='fs-5 fw-bold text-gray-900'>{detailName || 'User'}</span>
                <span className='text-muted fs-8'>{t("Support Chat")}</span>
              </div>
            </div>
          </div>

          {/* Messages */}
          <div className='chat-body-scroll px-5' ref={messagesContainerRef}>
            {isData ? (
              <>
                {messages.map((message, index) => {
                  const dateLabel = getFormattedDateLabel(message.time)
                  const showDateSeparator = dateLabel !== lastRenderedDate
                  lastRenderedDate = dateLabel
                  const state = message.type === 'ADMIN' ? 'bg-light-info' : 'bg-light-primary'
                  const contentClass = `d-flex justify-content-${message.type === 'ADMIN' ? 'end' : 'start'
                    } mb-1`

                  return (
                    <React.Fragment key={`message${index}`}>
                      {showDateSeparator && (
                        <div className='d-flex align-items-center my-5'>
                          <div
                            style={{
                              flex: 1,
                              height: '2px',
                              backgroundColor: '#ccc',
                              borderRadius: '1rem',
                            }}
                          ></div>
                          <div className='px-5 text-muted' style={{ whiteSpace: 'nowrap' }}>
                            <strong>{dateLabel}</strong>
                          </div>
                          <div
                            style={{
                              flex: 1,
                              height: '2px',
                              backgroundColor: '#ccc',
                              borderRadius: '1rem',
                            }}
                          ></div>
                        </div>
                      )}

                      <div className={clsx('d-flex', contentClass, 'mb-1')}>
                        <div
                          className={clsx(
                            'd-flex flex-column align-items',
                            `align-items-${message.type === 'USER' ? 'start' : 'end'}`,
                            'position-relative message-wrapper'
                          )}
                        >
                          {/* Optional User Info */}
                          {message.type === 'USER' &&
                            (() => {
                              const prevMessage = messages[index - 1]
                              const shouldShowUserDetails =
                                !prevMessage ||
                                prevMessage.type !== 'USER' ||
                                moment(message.time, 'DD/MM/YYYY hh:mm A').diff(
                                  moment(prevMessage.time, 'DD/MM/YYYY hh:mm A'),
                                  'minutes'
                                ) >= 1

                              return shouldShowUserDetails ? (
                                <div className='mt-2 d-flex align-items-center mb-2'>
                                  <div className='symbol symbol-35px symbol-circle'>
                                    <img
                                      alt='Pic'
                                      onError={(e) => {
                                        e.currentTarget.onerror = null
                                        e.currentTarget.src = toAbsoluteUrl(
                                          '/media/logos/mainLogo.png'
                                        )
                                      }}
                                      src={profile}
                                    />
                                  </div>
                                  <div className='ms-3'>
                                    <a
                                      href='#'
                                      className='fs-5 fw-bolder text-gray-900 text-hover-primary me-1'
                                    >
                                      {detailName}
                                    </a>
                                  </div>
                                </div>
                              ) : null
                            })()}

                          <div className='d-flex align-items-center'>
                            {message.type === 'ADMIN' && (
                              <span className='message-time-tooltip text-muted fs-7 align-self-start me-2'>
                                {message.time}
                              </span>
                            )}

                            <div
                              className={clsx(
                                'p-5 rounded text-break',
                                state,
                                'text-dark fw-bold mw-lg-400px',
                                'text-start rounded-top-start-0',
                                message.type === 'ADMIN' ? 'admin-rounded' : 'user-rounded'
                              )}
                              dangerouslySetInnerHTML={{
                                __html: formattedMessage(String(message.text)),
                              }}
                            ></div>

                            {message.type === 'USER' && (
                              <span className='message-time-tooltip text-muted fs-7 align-self-start ms-2'>
                                {message.time}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
                <div ref={bottomRef}></div>
              </>
            ) : (
              <div className='d-flex flex-column align-items-center justify-content-center text-center py-10'>
                <img
                  src={toAbsoluteUrl('/media/illustrations/sketchy-1/21.png')}
                  alt='No Messages Illustration'
                  className='mw-100 mh-300px theme-light-show mb-5'
                />
                <h3 className='fw-bold text-gray-700 mb-2'>{t("No Conversations Yet")}</h3>
                <p className='text-muted fs-6'>
                  {t("It looks like there are currently no messages in this conversation")}.
                  <br />
                  {t("Start chatting now to resolve this support")}.
                </p>
              </div>
            )}
          </div>

          {/* ✅ Scroll-to-Bottom Button */}
          {showScrollButton && (
            <button onClick={scrollToBottomSmooth} className='scroll-to-bottom-btn'>
              <KTIcon iconName='arrow-down' className='fs-2 kt-icon' />
            </button>
          )}

          {/* Footer */}
          <div className='p-4 border-top'>
            <div className='d-flex align-items-center gap-3'>
              <textarea
                className='form-control border rounded'
                rows={1}
                ref={textareaRef}
                placeholder={t('Type a message')}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={onEnterPress}
                style={{ resize: 'none' }}
              ></textarea>

              <button
                className='btn btn-primary d-flex align-items-center justify-content-center'
                type='button'
                onClick={sendMessage}
              >
                <KTIcon iconName='send' className='fs-2' />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { ChatInner }
